if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        if (!variantId) return;

        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute('available');
          this.innerHTML = '';
        }
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('pickup-availability-drawer');
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
        this.setAttribute('available', '');

        // Replace pickup time text immediately after rendering
        this.replacePickupTimeText();

        document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));
        const colorClassesToApply = this.dataset.productPageColorScheme.split(' ');
        colorClassesToApply.forEach((colorClass) => {
          document.querySelector('pickup-availability-drawer').classList.add(colorClass);
        });

        // Also replace in drawer
        const drawerElement = document.querySelector('pickup-availability-drawer');
        if (drawerElement) {
          this.replacePickupTimeTextInDrawer(drawerElement);
        }

        const button = this.querySelector('button');
        if (button)
          button.addEventListener('click', (evt) => {
            document.querySelector('pickup-availability-drawer').show(evt.target);
          });
      }

      replacePickupTimeText() {
        // Only target pickup-availability-info sections
        const pickupInfo = this.querySelector('.pickup-availability-info');
        if (!pickupInfo) return;

        const captionElements = pickupInfo.querySelectorAll('.caption');
        captionElements.forEach((el) => {
          if (!el) return;
          const text = el.textContent.trim();
          
          // Only replace pickup time text
          if (text && (text.includes('Usually ready') || text.includes('5+ days') || text.match(/ready in \d+\+ days?/i))) {
            // Hide original text
            el.classList.add('pickup-time-text-hidden');
            el.style.display = 'none';
            
            // Add replacement if not exists
            if (!pickupInfo.querySelector('.caption.pickup-replacement-text')) {
              const replacement = document.createElement('p');
              replacement.className = 'caption pickup-replacement-text';
              replacement.textContent = 'Pickup Available';
              el.parentNode.insertBefore(replacement, el.nextSibling);
            }
          }
        });
      }

      replacePickupTimeTextInDrawer(drawerElement) {
        const listItems = drawerElement.querySelectorAll('.pickup-availability-list__item');
        listItems.forEach((item) => {
          const captionElements = item.querySelectorAll('.caption-large');
          captionElements.forEach((el) => {
            if (!el) return;
            const text = el.textContent.trim();
            
            if (text && (text.includes('Usually ready') || text.includes('5+ days') || text.match(/ready in \d+\+ days?/i))) {
              // Replace text nodes directly
              const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
              let node;
              while (node = walker.nextNode()) {
                if (node.textContent.includes('Usually ready') || node.textContent.includes('5+ days') || node.textContent.match(/ready in \d+\+ days?/i)) {
                  node.textContent = node.textContent.replace(/Usually ready in \d+\+ days?/gi, 'Pickup Available');
                  node.textContent = node.textContent.replace(/ready in \d+\+ days?/gi, 'Pickup Available');
                }
              }
            }
          });
        });
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector('button').addEventListener('click', () => {
          this.hide();
        });

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest('pickup-availability-drawer') &&
          target.id != 'ShowPickupAvailabilityDrawer'
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        trapFocus(this);
        
        // Replace pickup time text when drawer opens
        this.replacePickupTimeTextInDrawerOnShow();
      }

      replacePickupTimeTextInDrawerOnShow() {
        const listItems = this.querySelectorAll('.pickup-availability-list__item');
        listItems.forEach((item) => {
          const captionElements = item.querySelectorAll('.caption-large');
          captionElements.forEach((el) => {
            if (!el) return;
            const text = el.textContent.trim();
            
            if (text && (text.includes('Usually ready') || text.includes('5+ days') || text.match(/ready in \d+\+ days?/i))) {
              // Replace text nodes directly
              const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
              let node;
              while (node = walker.nextNode()) {
                if (node.textContent.includes('Usually ready') || node.textContent.includes('5+ days') || node.textContent.match(/ready in \d+\+ days?/i)) {
                  node.textContent = node.textContent.replace(/Usually ready in \d+\+ days?/gi, 'Pickup Available');
                  node.textContent = node.textContent.replace(/ready in \d+\+ days?/gi, 'Pickup Available');
                }
              }
            }
          });
        });
      }
    }
  );
}
